import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalUnitTable from './portal-units-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-portal-admin-units')) {
  ReactDOM.render(<PortalUnitTable
    url= "/api/v1/portal/portal-admin/portal-units"
    message_if_none = 'No units in system yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-portal-admin-units'));
}
